import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import { rxGetQuestionnaireTemplateOfQuestionnaireHandler } from '@/rxdb/rxdb.api';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/questionnaire-template']['GET'];
type Input = ThisApi['params'];
type Config = { cache?: boolean };

const getQuestionnaireTemplateOfQuestionnaire = async ({ questionnaireId }: Input, { cache = false }: Config = {}): Promise<ThisApi['response']> => {
  const fetchFromApi = async (): Promise<ThisApi['response']> => {
    const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/questionnaire-template', { questionnaireId });
    const data = await formsBackendClient.get(path);
    return data.data;
  };

  if (!cache) return fetchFromApi();

  return rxGetQuestionnaireTemplateOfQuestionnaireHandler({ questionnaireId }, fetchFromApi);
};

export default getQuestionnaireTemplateOfQuestionnaire;
